<template>
  <div class="flex flex-col h-screen p-2 xl:p-4 sticky top-0">
    <!-- header logo -->
    <div class="w-full">
      <img class="w-2/4" :src="headerlogo" alt="" />
      <div class="w-full border-b border-1 border-light-gray my-4"></div>
    </div>
    <!-- navigation link -->
    <div class="h-full overflow-y-auto font-light">
      <!-- dashboard link -->
      <router-link to="/home" active-class="text-blue"
        class="flex flex-row text-gray text-sm lg:text-base xl:text-lg items-center mb-4">
        <Squares2X2Icon class="w-4 h-4 xl:w-6 xl:h-6 mr-2" />
        <p class="text-sm lg:text-base xl:text-lg">Dashboard</p>
      </router-link>
      <!-- admin link -->
      <router-link to="/admin" active-class="text-blue"
        class="flex flex-row text-gray text-sm lg:text-base xl:text-lg items-center mb-4">
        <UserIcon class="w-4 h-4 xl:w-6 xl:h-6 mr-2" />
        <p class="text-sm lg:text-base xl:text-lg">Admins</p>
      </router-link>
      <!-- team link -->
      <div @click="showTeamDropDown" class=" flex flex-row mb-4 justify-between items-center cursor-pointer select-none">
        <div class="flex">
          <UsersIcon class="w-4 h-4 xl:w-6 xl:h-6 mr-2 text-gray" />
          <p class="text-gray text-sm lg:text-base xl:text-lg font-sans">Team</p>
        </div>
        <ChevronUpIcon v-if="showTeamMenu" class="h-4 w-4 text-gray" />
        <ChevronDownIcon v-else class="h-4 w-4 text-gray" />
      </div>
      <!-- drop down menu -->
      <div v-if="showTeamMenu" class="select-none">
        <ul class="space-y-2 pb-4 text-lg ml-6 xl:ml-10">
          <li class="font-sans">
            <router-link active-class="text-blue" class="text-gray text-sm lg:text-base xl:text-lg" to="/manage_board_title">Manage
              Board
              Title</router-link>
          </li>
          <li class="text-gray font-sans">
            <router-link active-class="text-blue" class="text-gray text-sm lg:text-base xl:text-lg" to="/team">Manage
              Team</router-link>
          </li>
        </ul>
      </div>
      <!-- member link -->
      <div @click="showMemberDropDown"
        class=" flex flex-row mb-4 justify-between items-center cursor-pointer select-none">
        <div class="flex">
          <UserGroupIcon class="w-4 h-4 xl:w-6 xl:h-6 mr-2 text-gray" />
          <p class="text-gray text-sm lg:text-base xl:text-lg font-sans">Members</p>
        </div>
        <div class="flex flex-row items-center space-x-2">
          <div v-if="memberCount >= 1 && !showMemberMenu"
            class="px-2 h-5 bg-blue rounded-lg flex items-center justify-center">
            <p class="text-center text-white text-sm">{{ memberCount }}</p>
          </div>
          <ChevronUpIcon v-if="showMemberMenu" class="h-4 w-4 text-gray" />
          <ChevronDownIcon v-else class="h-4 w-4 text-gray" />
        </div>
      </div>
      <!-- drop down menu -->
      <div v-if="showMemberMenu" class="select-none">
        <ul class="space-y-2 pb-4 text-lg ml-6 xl:ml-10">
          <li class="font-sans">
            <router-link active-class="text-blue" class="text-gray text-sm lg:text-base xl:text-lg" to="/manage_member">Manage
              Members</router-link>
          </li>
          <li class="text-gray font-sans">
            <router-link active-class="text-blue" class="text-gray text-sm lg:text-base xl:text-lg" to="/request_member">
              <div class="flex flex-row items-center justify-between">
                <p class="text-sm lg:text-base xl:text-lg">Request Membership</p>
                <div v-if="memberRequestCount >= 1" class="px-2 h-5 bg-blue rounded-lg flex items-center justify-center">
                  <p class="text-center text-white text-sm">{{ memberRequestCount }}</p>
                </div>
              </div>
            </router-link>
          </li>
          <li class="text-gray font-sans">
            <router-link active-class="text-blue" class="text-gray text-sm lg:text-base xl:text-lg" to="/request_update">
              <div class="flex flex-row items-center justify-between">
                <p class="text-sm lg:text-base xl:text-lg">Request Update</p>
                <div v-if="requestUpdateCount >= 1" class="px-2 h-5 bg-blue rounded-lg flex items-center justify-center">
                  <p class="text-center text-white text-sm">{{ requestUpdateCount }}</p>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
      <!-- content link -->
      <div @click="showContentDropDown"
        class="flex flex-row mb-4 justify-between items-center cursor-pointer select-none">
        <div class="flex">
          <DocumentTextIcon class="w-4 h-4 xl:w-6 xl:h-6 mr-2 text-gray" />
          <p class="text-gray text-sm lg:text-base xl:text-lg font-sans">Contents</p>
        </div>
        <ChevronUpIcon v-if="showContentMenu" class="h-4 w-4 text-gray" />
        <ChevronDownIcon v-else class="h-4 w-4 text-gray" />
      </div>
      <!-- drop down menu -->
      <div v-if="showContentMenu" class="select-none">
        <ul class="space-y-2 pb-4 text-lg ml-6 xl:ml-10">
          <li class="text-gray font-sans">
            <router-link to="/manage_event" active-class="text-blue" class="text-gray text-sm lg:text-base xl:text-lg">
              Events
            </router-link>
          </li>
          <li class="text-gray font-sans">
            <router-link to="/manage_news" active-class="text-blue" class="text-gray text-sm lg:text-base xl:text-lg">
              News
            </router-link>
          </li>
          <li class="text-gray font-sans">
            <router-link to="/manage_opportunity" active-class="text-blue" class="text-gray text-sm lg:text-base xl:text-lg">
              Opportunity
            </router-link>
          </li>
          <li class="text-gray font-sans">
            <router-link to="/manage_page" active-class="text-blue"
              class="text-gray text-sm lg:text-base xl:text-lg">Pages</router-link>
          </li>
        </ul>
      </div>
      <!-- manage category link -->
      <router-link to="/manage_category" active-class="text-blue"
        class="flex flex-row text-gray text-sm lg:text-base xl:text-lg items-center mb-4">
        <FolderOpenIcon class="w-4 h-4 xl:w-6 xl:h-6 mr-2" />
        <p class="text-sm lg:text-base xl:text-lg">Manage Category</p>
      </router-link>
      <!-- manage member category link -->
      <router-link to="/member_category" active-class="text-blue"
        class="flex flex-row text-gray text-sm lg:text-base xl:text-lg items-center mb-4">
        <BookmarkIcon class="w-4 h-4 xl:w-6 xl:h-6 mr-2" />
        <p class="text-sm lg:text-base xl:text-lg">Member Category</p>
      </router-link>
      <!-- manage Working Sector link -->
      <router-link to="/member_sector" active-class="text-blue"
                   class="flex flex-row text-gray text-sm lg:text-base xl:text-lg items-center mb-4">
        <FolderOpenIcon class="w-4 h-4 xl:w-6 xl:h-6 mr-2" />
        <p class="text-sm lg:text-base xl:text-lg">Working Sector</p>
      </router-link>
      <!-- profile link -->
      <router-link to="/profile" active-class="text-blue"
        class="flex flex-row text-gray text-sm lg:text-base xl:text-lg items-center mb-4">
        <UserCircleIcon class="w-4 h-4 xl:w-6 xl:h-6 mr-2" />
        <p class="text-sm lg:text-base xl:text-lg">Profile</p>
      </router-link>
      <!-- subscription -->
      <div @click="showSubDropDown" class="
                                                                flex flex-row
                                                                mb-4
                                                                justify-between
                                                                items-center
                                                                cursor-pointer
                                                                select-none
                                                              ">
        <div class="flex">
          <ReceiptPercentIcon class="w-4 h-4 xl:w-6 xl:h-6 mr-2 text-gray" />
          <p class="text-gray text-sm lg:text-base xl:text-lg font-sans">Subscriptions</p>
        </div>
        <ChevronUpIcon v-if="showSubscriptionMenu" class="h-4 w-4 text-gray" />
        <ChevronDownIcon v-else class="h-4 w-4 text-gray" />
      </div>
      <!-- drop down menu -->
      <div v-if="showSubscriptionMenu" class="select-none">
        <ul class="space-y-2 pb-4 text-lg ml-6 xl:ml-10">
          <li class="text-gray font-sans">
            <router-link to="/manage_subscription" active-class="text-blue"
              class="flex flex-row text-gray text-sm lg:text-base xl:text-lg items-center mb-4">
              Manage Subsciptions
            </router-link>
          </li>
          <li class="text-gray font-sans">
            <router-link to="/manage_payment" active-class="text-blue"
              class="flex flex-row text-gray text-sm lg:text-base xl:text-lg items-center mb-4">
              Manage payments
            </router-link>
          </li>
        </ul>
      </div>
      <!-- notification link -->
      <router-link to="/notification" active-class="text-blue"
        class="flex flex-row text-gray text-sm lg:text-base xl:text-lg items-center mb-4">
        <BellAlertIcon class="w-4 h-4 xl:w-6 xl:h-6 mr-2" />
        <div class="w-full flex justify-between">
          <p class="text-sm lg:text-base xl:text-lg">Notifications</p>
          <div v-if="notificationCount >= 1" class="px-2 h-5 bg-red rounded-lg flex items-center justify-center">
            <p class="text-center text-white text-sm">{{ notificationCount }}</p>
          </div>
        </div>
      </router-link>
      <!-- inbox link -->
      <router-link to="/inbox" active-class="text-blue"
        class="flex flex-row text-gray text-sm lg:text-base xl:text-lg items-center mb-4">
        <InboxIcon class="w-4 h-4 xl:w-6 xl:h-6 mr-2" />
        <div class="w-full flex justify-between">
          <p class="text-sm lg:text-base xl:text-lg">Inbox</p>
          <div v-if="inboxCount >= 1" class="px-2 h-5 bg-red rounded-lg flex items-center justify-center">
            <p class="text-center text-white text-sm">{{ inboxCount }}</p>
          </div>
        </div>
      </router-link>
      <!-- user manaul -->
      <router-link to="/user-manual" active-class="text-blue"
        class="flex flex-row text-gray text-sm lg:text-base xl:text-lg items-center mb-4">
        <BookOpenIcon class="w-4 h-4 xl:w-6 xl:h-6 mr-2" />
        <p class="text-sm lg:text-base xl:text-lg">User Manual</p>
      </router-link>
    </div>
    <!-- profile and log out section -->
    <div class="mt-auto w-full text-left">
      <div class="w-full border-b border-1 border-light-gray my-4"></div>
      <div class="flex flex-row justify-between items-center">
        <div>
          <p class="text-blue font-sans">Hello,</p>
          <h1 class="text-blue text-2xl font-sans font-bold">
            {{ userData.name }}
          </h1>
        </div>
        <!-- <img
          class="w-1/4 rounded-full aspect-square object-cover"
          src="https://static.displate.com/857x1200/displate/2022-03-25/acd305536808283a7082353d7ab39d24_778c865af2d373e9de8a3bb26199bd1b.jpg"
          alt=""
        /> -->
      </div>
      <div @click="handleLogOut" class="group mt-2 flex flex-row items-center cursor-pointer">
        <ArrowLeftIcon class="h-5 w-5 text-red" />
        <p class="ml-2 text-red text-lg font-medium font-sans group-hover:underline">
          Log Out
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ArrowLeftIcon,
  Squares2X2Icon,
  UserIcon,
  UsersIcon,
  UserGroupIcon,
  DocumentTextIcon,
  UserCircleIcon,
  ReceiptPercentIcon,
  BellAlertIcon,
  InboxIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  FolderOpenIcon,
  BookmarkIcon,
  BookOpenIcon
} from "@heroicons/vue/24/solid";

export default {
  name: "SideBarNavigation",
  components: {
    ArrowLeftIcon,
    Squares2X2Icon,
    UserIcon,
    UsersIcon,
    UserGroupIcon,
    DocumentTextIcon,
    UserCircleIcon,
    ReceiptPercentIcon,
    BellAlertIcon,
    InboxIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    FolderOpenIcon,
    BookmarkIcon,
    BookOpenIcon
  },
  data() {
    return {
      userData: "",
      showMemberMenu: false,
      showSubscriptionMenu: false,
      showContentMenu: false,
      showTeamMenu: false,
    };
  },
  methods: {
    handleLogOut() {
      this.$store.dispatch("auth/logout");
      this.userData = [];
      this.$router.push("/login");
    },
    showMemberDropDown() {
      this.showMemberMenu = !this.showMemberMenu;
      this.showContentMenu = false;
      this.showSubscriptionMenu = false;
      this.showTeamMenu = false;
    },
    showContentDropDown() {
      this.showMemberMenu = false;
      this.showContentMenu = !this.showContentMenu;
      this.showSubscriptionMenu = false;
      this.showTeamMenu = false;
    },
    showSubDropDown() {
      this.showMemberMenu = false;
      this.showContentMenu = false;
      this.showSubscriptionMenu = !this.showSubscriptionMenu;
      this.showTeamMenu = false;
    },
    showTeamDropDown() {
      this.showMemberMenu = false;
      this.showContentMenu = false;
      this.showSubscriptionMenu = false;
      this.showTeamMenu = true;
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    inboxCount() {
      return this.$store.getters.inboxCount;
    },
    notificationCount() {
      return this.$store.getters.notificationCount;
    },
    memberRequestCount() {
      return this.$store.getters.memberRequestCount;
    },
    requestUpdateCount() {
      return this.$store.getters.requestUpdateCount;
    },
    memberCount() {
      return this.memberRequestCount + this.requestUpdateCount;
    },
    headerlogo() {
      return this.$store.getters.headerLogo;
    },
  },
  created() {
    if (this.loggedIn) {
      this.userData = localStorage.getItem("user");
      this.userData = JSON.parse(this.userData);
      this.userData = this.userData.data;
    }
  },
};
</script>

<style scoped>
.aspect-square {
  aspect-ratio: 1/1;
}

/* custom scrollbar */
::-webkit-scrollbar {
  width: 18px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #d6dee1;
  border-radius: 20px;
  border: 6px solid transparent;
  background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #a8bbbf;
}
</style>
